import React from "react";
import { partners } from "../mock";

const Partners = () => {
  const loop = [...partners, ...partners];
  return (
    <section className="py-16 bg-white border-y border-slate-100">
      <div className="pp-container text-center mb-8">
        <h2 className="text-2xl md:text-4xl font-extrabold text-[#0D1B2A]">
          Partner's who <span className="pp-grad-text-orange">Trust Us</span>
        </h2>
      </div>
      <div className="relative overflow-hidden">
        <div className="flex gap-8 w-max pp-marquee items-center">
          {loop.map((name, i) => (
            <div
              key={i}
              className="flex items-center gap-2.5 px-7 py-4 rounded-2xl border border-slate-100 bg-[#f6f9fd] whitespace-nowrap grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all"
            >
              <span className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm" style={{ background: "linear-gradient(135deg,#0D1B2A,#0EA5E9)" }}>
                {name.charAt(0)}
              </span>
              <span className="text-lg font-extrabold text-[#0D1B2A]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                {name}
              </span>
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
};

export default Partners;
